import React from "react";
import {
  Routes,
  Route,
  // BrowserRouter,
  Navigate,
  HashRouter,
} from "react-router-dom";
import { ProspectosIngreso } from "./pages/Prospectos-Ingreso/ProspectosIngreso";
import { ProspectosPrestadores} from "./pages/prestadores/ProspectosPrestadores";
import  PantallaDeSalida  from "./pages/pantalla-salida/PantallaDeSalida";
import TokenVencido from "./pages/token-vencido/TokenVencido";
import ErrorComunicacion from "./pages/error-comunicacion/ErrorComunicacion";
export function App() {
  return (
    <HashRouter>
      {/* <ProspectosIngreso /> */}
      {/* <BrowserRouter> */}
        <Routes>
          <Route
            path="/prospectos-ingreso"
            element={<ProspectosIngreso />}
          > </Route>
          <Route
            path="/token-vencido"
            element={<TokenVencido />}
          > </Route>
          <Route
            path="/error-comunicacion"
            element={<ErrorComunicacion />}
          > </Route>
          <Route
            path="/finalizar-gestion"
            element={<PantallaDeSalida />}
          > </Route>
          <Route
            path="/prestadores"
            element={<ProspectosPrestadores />}
          > </Route>
          <Route path="/*" element={<Navigate replace={true} to="/prospectos-ingreso" />}>  </Route>
        </Routes>
      {/* </BrowserRouter> */}
    </HashRouter>
  );
}

export default App;
